import { createStore, select, withProps } from "@ngneat/elf";
import { Injectable } from "@angular/core";

type ApplicationContext = stages.context.ApplicationContext;

interface AppContextProps {
	applicationContext?: ApplicationContext;
}

const applicationContextStore = createStore(
	{ name: "application-context" },
	withProps<AppContextProps>({ applicationContext: undefined }),
);

@Injectable({
	providedIn: "root",
})
export class ApplicationContextRepository {
	applicationContext$ = applicationContextStore.pipe(select((state) => state.applicationContext!));
	searchScope$ = applicationContextStore.pipe(select((state) => state.applicationContext!.searchScope));
	currentUser$ = applicationContextStore.pipe(select((state) => state.applicationContext!.userId));

	update(applicationContext: AppContextProps["applicationContext"]): void {
		applicationContextStore.update((state) => ({
			...state,
			applicationContext,
		}));
	}
}
